import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-product-setup',
  templateUrl: './customer-product-setup.component.html',
  styleUrls: ['./customer-product-setup.component.css']
})
export class CustomerProductSetupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
